import { StateCreator } from 'zustand'

export type ApiStatus = 'unknown' | 'available' | 'unavailable'

export type AppStatusState = {
  apiStatus: ApiStatus
}

export type AppStatusSlice = {
  appStatus: AppStatusState
}

export const appStatusSlice: StateCreator<
  AppStatusSlice,
  [],
  [],
  AppStatusSlice
> = (set, get) => {
  void set
  void get
  return {
    appStatus: {
      apiStatus: 'unknown',
    },
  }
}
